import Vue from 'vue';
import Auth from '~/plugins/Auth.js';

export default (app) => {
    Vue.use(Auth, [app.$cookies]);
};
